module.exports = __webpack_public_path__ + "img/synthesize_analyse.43908757.png";